// extracted by mini-css-extract-plugin
export var gatsbyImage = "Image-module--gatsby-image--bhuTM";
export var gatsbyImageUrl = "Image-module--gatsby-image-url--En+rj";
export var img = "Image-module--img--ekVnm";
export var imgPrivateOffer = "Image-module--img-private-offer--ETW1u";
export var notOptimized = "Image-module--not-optimized--Zc4ii";
export var placeholder = "Image-module--placeholder--OOmdx";
export var primary = "#06004d";
export var secondary = "#4dafd7";